// import { useEffect,useState } from "react"
// import axios from "axios"
// import { useParams } from "react-router-dom"
// import lbnlogo from '../Images/lbnlogo.png';
// import "./MemberProducts.css"
// import { useNavigate } from "react-router-dom";

// export default function MemberProducts(){

// const {email} = useParams()
// const navigate = useNavigate();
// const [products,setProducts] = useState([])

// useEffect(()=>{
//  fetchProducts()
// },[])

// const fetchProducts = async()=>{

//  try{

//  const res = await axios.get(
//  `https://api.lbnhyderabad.com/signup/api/memberflyer/products/${email}`
//  )

//  if(res.data.success){
//  setProducts(res.data.products)
//  }

//  }catch(err){
//  console.log(err)
//  }

// }

// const openWhatsapp = (product)=>{

//  const message = `Hello, I am interested in ${product.productName}`

//  const url = `https://wa.me/?text=${encodeURIComponent(message)}`

//  window.open(url,"_blank")

// }

// const sendEmail = (product)=>{

//  const subject = `Product Enquiry - ${product.productName}`

//  const body = `Hi, I would like to know more about ${product.productName}`

//  window.location.href =
//  `mailto:${email}?subject=${subject}&body=${body}`

// }

// return(
// <div className="member-products-page">
// <header className="memberflyer-header">

//   <div className="header-left">

  
//     <img
//       src={lbnlogo}
//       alt="logo"
//       className="header-logo"
//     />

//   </div>

//   <div className="header-title">
//     Member Flyer
//   </div>

// </header>
//   <button
//       className="back-btn1"
//       onClick={() => navigate("/memberflyer")}
//     >
//       ← Back
//     </button>

// <div className="products-container">

// <h2 className="products-title">
// Member Products
// </h2>

// <div className="products-grid1">

// {products.map(product=>(

// <div className="product-card1" key={product.id}>

// <img
// src={product.productPhoto}
// className="product-image1"
// />

// <h6>{product.productName}</h6>

// <p className="product-desc1">
// {product.productDesc}
// </p>

// <div className="price-row1">

// <span className="price1">
// ₹{product.productPrice}
// </span>

// {product.offer &&
// <span className="offer">
// {product.offer}% OFF
// </span>
// }

// </div>

// <div className="product-buttons1">

// <button
// className="email-btn1"
// onClick={()=>sendEmail(product)}
// >
// Email
// </button>

// <button
// className="whatsapp-btn1"
// onClick={()=>openWhatsapp(product)}
// >
// WhatsApp
// </button>

// </div>

// </div>

// ))}

// </div>

// </div>
// </div>
// )

// }

import { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import lbnlogo from '../Images/lbnlogo.png';
import "./MemberProducts.css";

export default function MemberProducts() {
  const { email } = useParams();
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [emailModalProduct, setEmailModalProduct] = useState(null);
  const [whatsappModalProduct, setWhatsappModalProduct] = useState(null);

  // Email form states
  const [customerName, setCustomerName] = useState("");
  const [customerMobile, setCustomerMobile] = useState("");
  const [customerEmail, setCustomerEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(null);

  // WhatsApp form states
  const [customerWName, setCustomerWName] = useState("");
  const [whatsappNumber, setWhatsappNumber] = useState("");

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const res = await axios.get(
        `https://api.lbnhyderabad.com/signup/api/memberflyer/products/${email}`
      );
      if (res.data.success) setProducts(res.data.products);
    } catch (err) {
      console.log(err);
    }
  };

  // Open Email Modal
  const openEmailModal = (product) => {
    setEmailModalProduct(product);
    setCustomerName("");
    setCustomerMobile("");
    setCustomerEmail("");
    setError(null);
  };
  const closeEmailModal = () => setEmailModalProduct(null);

  // Open WhatsApp Modal
  const openWhatsappModal = (product) => {
    setWhatsappModalProduct(product);
    setCustomerWName("");
    setWhatsappNumber("");
    setError(null);
  };
  const closeWhatsappModal = () => setWhatsappModalProduct(null);

  // Email submit
  const handleEmailSubmit = async () => {
    if (!customerName || !customerMobile || !customerEmail) {
      alert("Please fill all fields");
      return;
    }

    setSending(true);
    const referralData = {
      product: emailModalProduct.productPhoto,
      price: emailModalProduct.productPrice,
      name: emailModalProduct.productName,
      customerEmail,
      salerEmail: emailModalProduct.UserId, // adjust if needed
      customerName,
      customerMobile,
    };

    try {
      const response = await fetch(
        "https://api.lbnhyderabad.com/product/product-referral",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(referralData),
        }
      );
      const result = await response.json();
      if (!response.ok) throw new Error(result.message || "Something went wrong");
      alert("Referral sent successfully!");
      closeEmailModal();
    } catch (err) {
      setError(err.message);
    } finally {
      setSending(false);
    }
  };

  console.log("whatsappModalProduct",whatsappModalProduct)
  // WhatsApp submit
  const handleWhatsappSubmit = async () => {
    if (!customerWName || !whatsappNumber) {
      alert("Please fill all fields");
      return;
    }
    setSending(true);
    console.log("whatsappModalProduct",whatsappModalProduct)

    const referralData = {
      name: whatsappModalProduct.productName,
      salerEmail: whatsappModalProduct.UserId,
      customerName: customerWName,
      customerMobile: whatsappNumber,
    };

    try {
      const response = await fetch(
        "https://api.lbnhyderabad.com/product/product-referral-whatsapp",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(referralData),
        }
      );
      const result = await response.json();
      if (!response.ok) throw new Error(result.message || "Something went wrong");
      alert("Referral sent successfully via WhatsApp!");
      closeWhatsappModal();
    } catch (err) {
      setError(err.message);
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="member-products-page">
      <header className="memberflyer-header">
        <div className="header-left">
          <img src={lbnlogo} alt="logo" className="header-logo" />
        </div>
        <div className="header-title">Member Flyer</div>
      </header>

      <button className="back-btn1" onClick={() => navigate("/memberflyer")}>
        ← Back
      </button>

      <div className="products-container">
        <h2 className="products-title">Member Products</h2>
        <div className="products-grid1">
          {products.map(product => (
            <div className="product-card1" key={product.id}>
              <img src={product.productPhoto} className="product-image1" alt={product.productName} />
              <h6>{product.productName}</h6>
              <p className="product-desc1">{product.productDesc}</p>
              <div className="price-row1">
                <span className="price1">₹{product.productPrice}</span>
                {product.offer && <span className="offer">{product.offer}% OFF</span>}
              </div>
              <div className="product-buttons1">
                <button className="email-btn1" onClick={() => openEmailModal(product)}>Email</button>
                <button className="whatsapp-btn1" onClick={() => openWhatsappModal(product)}>WhatsApp</button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Email Modal */}
      {emailModalProduct && (
        <div className="flyer-m-email-modal-overlay">
          <div className="flyer-m-email-modal">
            <h3>Email Referral</h3>
            <input
              type="text"
              placeholder="Customer Name"
              value={customerName}
              onChange={e => setCustomerName(e.target.value)}
            />
            <input
              type="text"
              placeholder="Customer Mobile"
              value={customerMobile}
              onChange={e => setCustomerMobile(e.target.value)}
            />
            <input
              type="email"
              placeholder="Customer Email"
              value={customerEmail}
              onChange={e => setCustomerEmail(e.target.value)}
            />
            {error && <p className="error-text">{error}</p>}
            <button onClick={handleEmailSubmit} disabled={sending}>
              {sending ? "Sending..." : "Send"}
            </button>
            <button onClick={closeEmailModal} className="modal-close-btn">Close</button>
          </div>
        </div>
      )}

      {/* WhatsApp Modal */}
      {whatsappModalProduct && (
        <div className="flyer-m-whatsapp-modal-overlay">
          <div className="flyer-m-whatsapp-modal">
            <h3>WhatsApp Referral</h3>
            <input
              type="text"
              placeholder="Customer Name"
              value={customerWName}
              onChange={e => setCustomerWName(e.target.value)}
            />
            <input
              type="text"
              placeholder="WhatsApp Number"
              value={whatsappNumber}
              onChange={e => setWhatsappNumber(e.target.value)}
            />
            {error && <p className="error-text">{error}</p>}
            <button onClick={handleWhatsappSubmit} disabled={sending}>
              {sending ? "Sending..." : "Send"}
            </button>
            <button onClick={closeWhatsappModal} className="modal-close-btn">Close</button>
          </div>
        </div>
      )}
    </div>
  );
}